import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'vbTimespanToSeconds' })
export class VbTimespanToSecondsPipe implements PipeTransform {
	public transform(milliseconds: number): string {
		return (milliseconds / 1000).toFixed(2);
	}
}
